export default __webpack_public_path__ + "static/img_6-6d10f37300d404e7d4f31af64b7fa48e.webp";